<template>
<div>
    <div class="container clearfix">
        All apps
    </div>
</div>
</template>